export const RegExpLinks = /^((ftp|http|https):\/\/)?(www\.)?([A-Za-zА-Яа-я0-9]{1}[A-Za-zА-Яа-я0-9\-]*\.?)*\.{1}[A-Za-zА-Яа-я0-9-]{2,8}(\/([\w#!:.?+=&%@!\-\/])*)?/
export const RegExpTel = /[0-9]/
export const RegExpEmail = /[a-z0-9]+@[a-z]+\.[a-z]{2,3}/
export const RegExpCoordinate = /^(-?\d+(\.\d+)?).\s*(-?\d+(\.\d+)?)$/
